var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltipOnboardingArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 0-.4223.844584c-.2519.503856-.3779.755786-.5049.984276-2.02593 3.64582-5.79969 5.97813-9.96665 6.15976C.844995 8 .56333 8 0 8h24c-.5633 0-.845 0-1.1062-.01138-4.1669-.18163-7.9407-2.51394-9.9666-6.15976-.127-.22848-.253-.4804-.5049-.984217V.844584L12 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipOnboardingArrow);
export default __webpack_public_path__ + "static/media/tooltipOnboardingArrow.b4d20885dd51e80d333becadd84320ab.svg";
export { ForwardRef as ReactComponent };